import functions from './functions';

$(() => {
    listTravel.init();
});

const listTravel = {
    $form: null,
    params: {},
    page: 1,
    total: 0,
    defaults: {
        page: 1,
        perPage: 6,
    },
    init() {
        listTravel.$form = $('form[data-objectGroupId="6"]');

        if (! listTravel.$form.length) {
            return;
        }

        listTravel.prefillForm();
        listTravel.fetchList();
        listTravel.bindEvents();
    },
    bindEvents() {
        listTravel.$form.on('change', 'input[name="countryId"]', e => {
            const $countryId = listTravel.$form.find('input[name="countryId"]');

            if (e.currentTarget.value === '') {
                $countryId.not(e.currentTarget).prop('checked', false);
            } else if (e.currentTarget.checked) {
                $countryId.filter('[value=""]').prop('checked', false);
            }

            if (! $countryId.filter(':checked').length) {
                $countryId.filter('[value=""]').prop('checked', true);
            }
        });

        listTravel.$form.on('change', () => {
            listTravel.page = 1;
            listTravel.fetchList();
        });

        $(document).on('click', '.list-pagination [data-page]', e => {
            e.preventDefault();
            const page = parseInt(e.currentTarget.getAttribute('data-page'), 10);

            if (! page || page === listTravel.page) {
                return;
            }

            listTravel.page = page;
            listTravel.fetchList();
        });
    },
    prefillForm() {
        functions.setFormData(listTravel.$form[0], functions.getUrlData(true));
    },
    paramsForUrl() {
        const params = $.extend({}, listTravel.params);

        $.each(listTravel.defaults, (key, value) => {
            if (params[key] == value) {
                delete params[key];
            }
        });

        return params;
    },
    skeletonCard() {
        return '<div class="card-travel-h mb-3">'
            + '<div class="card-travel-h__image skeleton-block"></div>'
            + '<div class="card-travel-h__content">'
                + '<div class="card-travel-h__heading">'
                    + '<div class="skeleton-line skeleton-line--title"></div>'
                    + '<div class="skeleton-circle"></div>'
                + '</div>'
                + '<div class="skeleton-line skeleton-line--meta"></div>'
                + '<div class="skeleton-line skeleton-line--dates"></div>'
                + '<div class="skeleton-line skeleton-line--tags"></div>'
                + '<div class="skeleton-line skeleton-line--text"></div>'
                + '<div class="skeleton-line skeleton-line--text-short"></div>'
            + '</div>'
        + '</div>';
    },
    skeletonMeta() {
        return '<div class="list-meta"><div class="skeleton-line skeleton-line--total"></div></div>';
    },
    fetchList() {
        listTravel.params = functions.getFormData(listTravel.$form);
        listTravel.params.page = listTravel.page;

        functions.setUrlData(listTravel.paramsForUrl(), true);

        $('.list .list-items').html(listTravel.skeletonMeta() + listTravel.skeletonCard().repeat(6));

        return $.getJSON(
            location.protocol
            + '//'
            + location.hostname
            + '/services/list/?'
            + 'objectGroupId=6'
            + '&' + $.param(listTravel.params)
        ).done(response => {
            
            listTravel.total = response.total;
            $('.list .list-items').html(response.html);
            window.observer.observe();
        });
    },
};

export {
    listTravel,
};
